import {Step} from "./Step";
import FormStep from "../../components/form/steps/FormStep";

export class BasicStep extends Step {
    constructor(component = FormStep) {
        super(component);
        this._next_step = null;

        this._fields = [];
    }

    nextStep(value) {
        this._next_step = value;
        return this;
    }



    addFields(fields) {
        this._fields = {...this._fields, ...fields};
        return this;
    }

    /**
     * If don't give value, default to step fields
     * !! need to be after addFields()
     *
     * @param {array|boolean} value
     * @return BasicStep
     * */
    addFieldsToSend(value = true) {
        if (value === true) {
            this._fields_to_send = [...this._fields_to_send,..._.keys(this._fields)]
        }
        if(_.isArray(value)){
            this._fields_to_send = [...this._fields_to_send,...value];
        }
        return this;
    }

}
